/**
 * {
	"messageType": "alertNotification",
	"notificationId": 1645742025874,
	"notificationDetails": {"updateType":"OPTION_FILTER_FAILED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TIGHT_SPREAD_PCT",
	"statusDetails": {"pct":0.25},
	"date": "2022-02-24T17:33:47.099-0500",
	"timestamp": "1645742027102"
}
 * @param {*} statusDetails 
 * @returns pct: that the user configured his tight spread cents filter for
 */
export function tightSpreadPctParser(statusDetails) {
  const parsedObj = {
    pct: null,
  };
  if (statusDetails) {
    parsedObj.pct = statusDetails.pct ?? null;
  }

  return parsedObj;
}
